import { render, staticRenderFns } from "./SwitchesTop.vue?vue&type=template&id=1b2a507c&scoped=true&"
import script from "./SwitchesTop.vue?vue&type=script&lang=js&"
export * from "./SwitchesTop.vue?vue&type=script&lang=js&"
import style0 from "./SwitchesTop.vue?vue&type=style&index=0&id=1b2a507c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a507c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSelect,VSwitch})
